// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "figure[data-v-5fdab5ac]{cursor:pointer}.media[data-v-5fdab5ac]{margin:0!important;padding:.5rem}.media[data-v-5fdab5ac]:hover{background:#f3f2f3}.media[data-v-5fdab5ac]:nth-child(2n){background:#fafafa}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
